import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import logo from './logo.svg';
import './App.css';
import VCardPage from './pages/v_card_page';
import PdfReader from './components/PdfReader'


function App() {

  return (
    <Router>
      <Routes>
        <Route path="/vcard/:code" element={<VCardPage></VCardPage>} />
        <Route path="/pdf" element={<PdfReader></PdfReader>} />
      </Routes>
    </Router>
  );
}

export default App;
